export default {
  "welcome.upgrade.headline": "Mit EDEKA StartHub den Weg in die Regale finden",
  "welcome.upgrade.tagline":
    "Du möchtest Dein Produkt auf der EDEKA StartHub Plattform unseren Kaufleuten präsentieren und zum Verkauf anbieten?",

  "welcome.welcome.headline": "EDEKA StartHub sagt hi!",
  "welcome.welcome.tagline":
    "Willkommen bei EDEKA StartHub! Hier findest Du alle relevanten Informationen, um Deine Produkte im Handel zu platzieren.",
};
